/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Stack } from '@mui/material';

import SlideWrapper from '../SlideWrapper';

import { VerticalRoadmapPanel } from './panel';

function RoadmapSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Stack spacing={12}>
        <VerticalRoadmapPanel
          stepTitle={'Q1 2022'}
          subtitle={'Vesta is born, new collaterals are added'}
          highlight={'completed'}
        >
          A new protocol aiming at delivering the highest level of quality is born. Its name? Vesta. <br />
          <br /> Thanks to its rapid success, Vesta has forged strong partnerships with key players in the
          ecosystem, such as GMX and Dopex. These partnerships have been further strengthened by the inclusion
          of their native tokens as collateral options within the Vesta platform.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q2 2022'}
          subtitle={'Collateral Mobilization: GMX and GLP Mobilized'}
          highlight={'completed'}
        >
          Vesta recognized the potential loss in revenue caused by large amounts of idle assets remaining on
          user&apos;s vaults and pioneered a solution called Collateral Mobilization. This process involves
          deploying assets in vaults to existing staking modules, allowing them to generate rewards which are
          then distributed back to the vault holders, boosting capital efficiency.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q3 2022'}
          subtitle={'Vesta Reference Rate, Established Vesta Emergency Reserve'}
          highlight={'completed'}
        >
          In response to issues arising from redemption, Vesta launched the Vesta Reference Rate. This
          interest rate, charged to vault holders, is based on deviations of VST from its peg, allowing the
          end of redemptions and providing more stability to the system. The VST collected are directly
          streamed to the Vesta Emergency Reserve, which will be used to compensate users in case of a
          shortfall event.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q4 2022'}
          subtitle={'Vesta Trader: an internally-used DEX aggregator, was created'}
          highlight={'completed'}
        >
          Vesta Trader, an internally-used DEX aggregator, was created to enhance the user experience by
          providing seamless trading between DEXs. This innovation is currently being utilized to power
          features such as Closing Vault with Collateral.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q1 2023'}
          subtitle={'VST Saving Module, VSTA Staking Module'}
          highlight={'current'}
        >
          The Saving Module, funded by the Reference Rate, enables users to earn up to 10% by locking up VST
          for a period of up to 90 days. These locked-up funds are used as a secondary security buffer to
          backstop liquidation, similar to stability pools, to further strengthen the system and make VST the
          most secure crypto-backed stablecoin in the market. <br /> <br /> Governance Staking Module Users
          can get the most out of their VSTA or VSTA-ETH LP tokens by locking them to earn a call option on
          VSTA. This means that stakers are granted the right to purchase VSTA at a certain price, known as
          the strike price, which is adjusted in relation to the market price of VSTA.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q2+ 2023'}
          subtitle={'Further expansion of VST use cases, making VST the go-to stable on Arbitrum'}
          highlight={'upcoming'}
        >
          Expansion of VST use cases and development of strategic partnerships to establish VST as the leading
          stablecoin on Arbitrum. Efforts will be put into scaling VST to its full potential, making it the
          go-to choice for new and experienced Arbitrum users.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q3+ 2023'}
          subtitle={'VestaLend: a product that allows users to lend and leverage all assets with ease'}
          highlight={'upcoming'}
        >
          VestaLev is a unique feature that allows users to lend and leverage all supported assets with ease.
          Thanks to its order book system, the loan-making on the platform could aim to a close-to-100%
          utilization rate.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel
          stepTitle={'Q3+ 2023'}
          subtitle={'VestaLend: a product that allows users to lend and leverage all assets with ease'}
          highlight={'upcoming'}
        >
          VestaLev is a unique feature that allows users to lend and leverage all supported assets with ease.
          Thanks to its order book system, the loan-making on the platform could aim to a close-to-100%
          utilization rate.
        </VerticalRoadmapPanel>
        <VerticalRoadmapPanel stepTitle={'2023 AND BEYOND...'} highlight={'upcoming'}>
          At Vesta, we believe that a flexible approach is key in an ever-changing environment. We view our
          roadmap as a dynamic tool, regularly updated to capture emerging possibilities. By remaining open to
          new possibilities, we can capitalize on opportunities as they arise and ensure pro-activity in our
          strategy and decision-making.
        </VerticalRoadmapPanel>
      </Stack>
    </SlideWrapper>
  );
}

export default RoadmapSlide;
